import React from "react";
import HeroSection from "../components/HeroSection";
import StatsSection from "../components/StatsSection";
import MissionHowItWorks from "../components/MissionHowItWorks";
import FeaturesSectionNew from "../components/FeaturesSectionNew";
import KnowledgeBase from "../components/KnowledgeBase";
import Security from "../components/Security";
import Compare from "../components/Compare";
import Testimonials from "../components/Testimonials";

export const HomePage = ({ onLogin }) => {
  return (
    <div className="home-page__main">
      <HeroSection />
      <StatsSection />
      <MissionHowItWorks onLogin={onLogin} />
      <Compare />
      <Security />
      <FeaturesSectionNew />
      <div className="home-faqs-wrapper">
        <div className="content-wrapper">
          <KnowledgeBase />
        </div>
      </div>
    </div>
  );
};
